/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import { FOCUSABLE_ELEMENTS as n } from "@progress/kendo-react-common";
const r = (e) => {
  if (e) {
    const t = e.querySelectorAll(n.join(", "));
    if (t.length)
      return t[0];
  }
}, l = (e) => {
  if (e) {
    const t = e.querySelectorAll(n.join(", "));
    if (t.length)
      return t[t.length - 1];
  }
}, c = (e) => {
  const t = r(document.querySelector(".k-popover-inner")), o = l(document.querySelector(".k-popover-inner"));
  e.shiftKey && e.target === t ? (o && o.focus(), e.preventDefault()) : !e.shiftKey && e.target === o && (t && t.focus(), e.preventDefault());
};
export {
  r as getFirstFocusableElement,
  l as getLastFocusableElement,
  c as handleFocusTrap
};
